import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { KnowledgeBuilderField } from '../components/KnowledgeBuilder';
import {
  knowledgeBuilderUiOptionsSchema,
  knowledgeBuilderValueSchema,
} from '../schemas/knowledgeBuilderSchema';

export const knowledgeBuilderFieldExtension: any = FormFieldBlueprint.make({
  name: 'knowledge-builder',
  params: {
    field: async () =>
      createFormField({
        name: 'KnowledgeBuilder',
        component: KnowledgeBuilderField,
        schema: makeFieldSchema({
          output: () => knowledgeBuilderValueSchema,
          uiOptions: () => knowledgeBuilderUiOptionsSchema,
        }),
      }),
  },
});
